module.exports = __webpack_public_path__ + "color_palette_rvcnn.png?77ffa119f213d75dd2b38f22f26e7e96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/color_palette_rvcnn.png
// module id = 94
// module chunks = 0